import { CONTACTUS_PATH } from '../../constants'
import AbstractService from '../../services/AbstractService'
import { ServerResponse } from '../../types'

class ContactUsClass extends AbstractService {
  sendFormData = (data: FormData /*& { captchaToken: string }*/) =>
    this.request<ServerResponse<{ id: string }>>(CONTACTUS_PATH, 'post', true, data)
}

export const ContactUsService = new ContactUsClass()
